import { AdditionalEmailTools, WebBuilderFeature, OtherServices, PricingPlan, PlanIncluded, SectionPersonalizedEmail } from "@/components/features/emailhosting";
import { EmailHostingHero } from "@/components/features/emailhosting";
import Footer from "../../components/common/layout/Footer";
import AnimatedSection from "../../components/common/animations/AnimatedSection";
import ParallaxSection from "../../components/common/animations/ParallaxSection";
import Floating3D from "../../components/common/animations/Floating3D";
import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { motion } from "framer-motion";
import SEO from "@/components/common/seo/seo";

if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
}

export default function EmailHosting() {
    useEffect(() => {
        // Stagger animation for cards
        const cards = document.querySelectorAll('.email-card');

        cards.forEach((card, index) => {
            gsap.fromTo(card,
                {
                    opacity: 0,
                    y: 60,
                    rotationY: -20,
                    scale: 0.8
                },
                {
                    opacity: 1,
                    y: 0,
                    rotationY: 0,
                    scale: 1,
                    duration: 0.8,
                    delay: index * 0.15,
                    ease: "back.out(1.7)",
                    scrollTrigger: {
                        trigger: card,
                        start: "top 80%",
                        toggleActions: "play none none none"
                    }
                }
            );
        });

        // Floating animation for hero elements
        gsap.to('.floating-element', {
            y: -20,
            duration: 2,
            repeat: -1,
            yoyo: true,
            ease: "sine.inOut",
            stagger: 0.2
        });

        return () => {
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
        };
    }, []);

    return (
        <>
            <SEO
                title="Professional Email Hosting - SAN micron"
                description="Reliable and secure email hosting with custom email addresses, powerful spam protection, and easy access on all devices for individuals and businesses."
            />
            <div className="relative overflow-hidden">
                <ParallaxSection speed={0.25}>
                    <Floating3D intensity={18}>
                        {/* <div className="floating-element"> */}
                        <EmailHostingHero />
                        {/* <WebBuilderFeature /> */}
                        {/* </div> */}
                    </Floating3D>
                </ParallaxSection>

                <AnimatedSection delay={0.2} direction="up">
                    <motion.div
                        className="email-card"
                        whileHover={{ scale: 1.02, y: -5 }}
                        transition={{ type: "spring", stiffness: 300 }}
                    >
                        <OtherServices />
                        <PricingPlan />
                        <WebBuilderFeature />
                    </motion.div>
                </AnimatedSection>

                <ParallaxSection speed={0.3} direction="down">
                    <AnimatedSection delay={0.3} direction="left">
                        <div className="email-card">
                            <Floating3D intensity={12}>
                                <SectionPersonalizedEmail />
                                <PlanIncluded />
                            </Floating3D>
                        </div>
                    </AnimatedSection>
                </ParallaxSection>

                <ParallaxSection speed={0.2}>
                    <AnimatedSection delay={0.5} direction="up">
                        <div className="email-card">
                            {/* <Floating3D intensity={15}>
                                <CallToAction />
                            </Floating3D> */}
                            <AdditionalEmailTools />
                        </div>
                    </AnimatedSection>
                </ParallaxSection>

                <AnimatedSection delay={0.6}>
                    <div className="abstract-bg email-card">
                        {/* <FAQ /> */}
                        {/* <Nas /> */}
                    </div>
                </AnimatedSection>

                <AnimatedSection delay={0.7}>
                    <Footer />
                </AnimatedSection>
            </div>
        </>
    );
}